import * as React from "react";

interface PackageStatusProps {
  link?: string;
  img: string;
  alt: string;
}

export default function PackageStatus(props: PackageStatusProps) {
  return (
    <a href={props.link || props.img} style={{ margin: "0em 0.2em" }}>
      <img src={props.img} alt={props.alt} />
    </a>
  );
}
